export default __webpack_public_path__ + "static/media/fast-delivery-fast.8472063a.svg";